import axios from "../axiosInstance";
import type { LibraryModule } from "@/modules/learningCenter/features/ModuleLibrary/types/libraryModule.types";

interface PublishResponse {
  message: string;
  module: LibraryModule;
}

/**
 * Publish a library module (make it available for use in courses)
 */
export const publishLibraryModule = async (id: number): Promise<PublishResponse> => {
  const response = await axios.patch<PublishResponse>(
    `/api/learning-center/module-library/${id}/publish`
  );
  return response.data;
};

export default publishLibraryModule;
